import { MouseEvent, ReactNode, useRef } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { INotificationFirmData } from 'types/DashboardType'
import { saveAsExcelFile } from 'utils/Miscellaneous'
import { Button } from 'primereact/button'
import { OverlayPanel } from 'primereact/overlaypanel'

interface CompProps {
  children: ReactNode
  excelData: any
}

export default function PersonalDist({ excelData, children }: CompProps) {
  const { t } = useTranslation()
  const addToExcel = useRef<OverlayPanel>(null)
  const showExcel = (e: MouseEvent<HTMLButtonElement>) => addToExcel.current?.show(e, e.target)

  const handleExport = () => {
    import('xlsx').then((xlsx) => {
      let heading = [
        [
          t('most-used-words.firm'),
          t('most-used-words.location'),
          t('dashboard.firm-office-notification'),
          t('dashboard.shared-office-notification'),
          t('dashboard.remote-office-notification'),
          t('dashboard.num-of-all-notification'),
        ],
      ]

      const arr = excelData?.map((res: any) => {
        const {
          firmName,
          locationName,
          officeReservationCount,
          sharedOfficeReservationCount,
          homeOfficeReservationCount,
          totalReservationCount,
        } = res

        return {
          firmName: firmName || '---',
          locationName: locationName || '',
          officeReservationCount: officeReservationCount,
          sharedOfficeReservationCount: sharedOfficeReservationCount,
          homeOfficeReservationCount: homeOfficeReservationCount,
          totalReservationCount: totalReservationCount,
        }
      })

      const totalRow = arr.reduce(
        (acc: INotificationFirmData, curr: INotificationFirmData) => {
          acc.officeReservationCount += curr.officeReservationCount || 0
          acc.sharedOfficeReservationCount += curr.sharedOfficeReservationCount || 0
          acc.homeOfficeReservationCount += curr.homeOfficeReservationCount || 0
          acc.totalReservationCount += curr.totalReservationCount || 0
          return acc
        },
        {
          firmName: '',
          locationName: t('most-used-words.total'),
          officeReservationCount: 0,
          sharedOfficeReservationCount: 0,
          homeOfficeReservationCount: 0,
          totalReservationCount: 0,
        }
      )

      let heading2 = {
        firmName: '',
        officeReservationCount: t('dashboard.excel.firm-office-person'),
        sharedOfficeReservationCount: t('dashboard.excel.shared-office-person'),
        homeOfficeReservationCount: t('dashboard.excel.remote-office-person'),
        totalReservationCount: t('dashboard.excel.total-person-res'),
      }

      arr.push(...[{}, heading2, totalRow])

      /* header */
      const ws = xlsx.utils.book_new()
      xlsx.utils.sheet_add_aoa(ws, heading)
      const worksheet = xlsx.utils.sheet_add_json(ws, arr!, { origin: 'A2', skipHeader: true })
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
      saveAsExcelFile(excelBuffer, t('dashboard.excel.person-file-name'))
    })
  }

  return (
    <>
      {!!excelData && excelData?.length ? (
        <div className="w-100 d-flex justify-content-end mb-2">
          <Button
            onMouseOver={(e) => showExcel(e)}
            onMouseLeave={() => addToExcel.current?.hide()}
            className="p-button-plain p-button-rounded p-button-text export-btn"
            onClick={handleExport}>
            <i className="pi pi-file-excel excelIcon" style={{ fontSize: '20px', cursor: 'pointer' }}></i>
          </Button>

          <OverlayPanel ref={addToExcel} className="add-excel-panel">
            <div className="add-excel-text">
              <p>{t('overlaypanel-texts.export-excel')}</p>
            </div>
          </OverlayPanel>
        </div>
      ) : null}

      {children}
    </>
  )
}
